module.exports = __webpack_public_path__ + "img/text02.d8f9dff7.png";